<template>
  <md-field class='select' :class='{ "md-invalid": errors.length }'>
    <label v-if='label'>
      {{ label }}
    </label>
    <md-select
        :value='value'
        @input='onChange'
        :placeholder='placeholder'
        :disabled='disabled'
        v-bind='inputProps'
    >
      <slot/>
    </md-select>
    <span
        class='md-error'
        v-if='errors.length'
        v-for='error in errors'
    >
      {{ $t(`errors.${error}`) }}
    </span>
  </md-field>
</template>

<script>
  export default {
    name: 'x-select',
    model: {
      prop: 'value',
      event: 'update'
    },
    props: {
      inputProps: {
        type: Object,
        default: () => ({})
      },
      value: {
        type: [String, Number]
      },
      label: {
        type: String,
        default: null
      },
      placeholder: {
        type: String,
        default: null
      },
      errors: {
        type: Array,
        default: () => []
      },
      valueKey: {
        type: String,
        default: 'id'
      },
      options: Array,
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onChange (value) {
        this.$emit('update', value)
      }
    }
  }
</script>

